import React, { Component } from 'react';

class BoldTextFormatter extends Component {
  render() {
    const { value } = this.props;
    let quantity = value;
    if (isNaN(parseInt(value))) {
      quantity = '-'
    } 
    return <span style={{ 'font-weight': 'bold' }}>{quantity}</span>;
  }
}

export default BoldTextFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/boldTextFormatter.jsx